import api from "./api";

interface SidebarFolderRenameParams {
  folder_id: string;
  name: string;
}

interface SidebarFolderRenameProps {
  folderId: string;
  name: string;
}

// 文件夹重命名
export const sidebarFolderRename = async (props: SidebarFolderRenameProps) => {
  const params: SidebarFolderRenameParams = {
    folder_id: props.folderId,
    name: props.name,
  };
  const res = await api.post<unknown>("/sidebar/folder/rename", params);
  return res;
};
